// export const secondsToSexagesimal = durationSeconds => {
//   let time = durationSeconds;
//   const hours = Math.floor(time / 3600);
//   time -= hours * 3600;
//   const minutes = Math.floor(time / 60);
//   time -= minutes * 60;
//   const seconds = time < 10 ? `0${time}` : time;
//   return `${hours ? hours + ':' : ''}${minutes}:${seconds}`;
// };

export const secondsToSexagesimal = val => {
  if (isNaN(parseInt(val, 10))) {
    return '';
  }
  const hours = Math.floor(val / 3600);
  const minutes = Math.floor(val / 60) % 60;
  const seconds = Math.floor(val) % 60;

  const minutesString = hours ? minutes.toString().padStart(2, '0') : minutes.toString();
  return `${hours ? hours + ':' : ''}${minutesString}:${seconds.toString().padStart(2, '0')}`;
};



// WEBPACK FOOTER //
// ./src/utils/time.js